import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const ModalWrapper = styled(Column)`
  width: 620px;
`;

export const Content = styled(Column)`
  padding: 0 20px 0px 20px;
  max-height: 644px;
  background-color: ${({ theme }) => theme.colors.bodyBg};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow-y: auto;
`;
